// extracted by mini-css-extract-plugin
module.exports = {"toggle__container":"style_toggle__container__u9Hu4","toggle__button":"style_toggle__button__odPaq","toggle__deactivate":"style_toggle__deactivate__mTOis"};